import { Head } from "@inertiajs/react"
import AdminLayout from "../../../layouts/AdminLayout"
import SentenceFormView, { SentenceForm } from "./Form"

type Props = { sentence: SentenceForm; topics: { id: number; name: string }[]; errors?: Record<string, string[]> }

export default function EditSentence({ sentence, topics, errors }: Props) {
  return (
    <AdminLayout title="Edit sentence">
      <Head title="Edit sentence" />
      <SentenceFormView sentence={sentence} topics={topics} errors={errors} />
    </AdminLayout>
  )
}
